import Behavior from 'dashboard/components/GraphCanvasV2/behaviors/behavior';
import { default as _CanvasSelectablesSelectionBehavior } from 'dashboard/components/GraphCanvasV2/behaviors/canvas-selectables-selection-behavior';
import { default as _Mode } from 'dashboard/components/GraphCanvasV2/behaviors/mode';

export const CanvasSelectablesSelectionBehavior = _CanvasSelectablesSelectionBehavior;
export const Mode = _Mode;
export default Behavior;
